import { Component, input } from '@angular/core';

export type RibbonType = 'beta' | 'idea' | 'prototype' | 'product' | 'coming soon';

@Component({
  selector: 'app-ribbon',
  imports: [],
  templateUrl: './ribbon.component.html',
  styleUrl: './ribbon.component.css',
})
export class RibbonComponent {
  public type = input.required<RibbonType>();
}
